module.exports = require("string_decoder");